import { toggle_off, toggle_on } from "../../../assets/img";

export const bar_chart = [
  {
    label: "January",
    value: 200,
  },
  {
    label: "February",
    value: 45,
  },
  {
    label: "March",
    value: 300,
  },
  {
    label: "April",
    value: 100,
  },
  {
    label: "May",
    value: 150,
  },
  {
    label: "June",
    value: 210,
  },
  {
    label: "July",
    value: 120,
  },
  {
    label: "August",
    value: 140,
  },
];

export const couponOptions = [
  { value: "south1", label: "South 1" },
  { value: "south2", label: "South 2" },
  { value: "south3", label: "South 3" },
  { value: "north", label: "North" },
  { value: "west", label: "West" },
  { value: "central", label: "Central" },
];

export const admin_list = [
  {
    id: 1,
    name: "RamKumar",
    role: "Super Admin",
    user: "Aravind",
    email: "ramkumar@gmail.com",
    password: "Ramkumar",
    status: "on",
    propertyStatus: 1,
    type: "Mobile",
    number: "9878098077",
    toggle: "on",
    deviceId: "KW-038",
    client: "Device1",
    assigned: "Sathish",
    location: "Hyderabad",
    city: "Chennai",
    propertyName: "Enistin",
    propertyId: "AI002",
    propertyType: "Room",
    propName: "Masters - Property Content",
    age: "28",
    imageCount: "5",
    fromDate: "15-03-2025",
    toDate: "16-03-2025",
    category: "Villa",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
  {
    id: 2,
    name: "Varun",
    role: "Admin",
    user: "Varun",
    email: "varun@gmail.com",
    password: "Varun",
    status: "off",
    propertyStatus: 2,
    type: "CRM",
    number: "9435098077",
    toggle: "off",
    status: "off",
    deviceId: "KW-058",
    client: "Device2",
    assigned: "Sambath",
    location: "Madurai",
    city: "Tambaram",
    propertyName: "Kudan",
    propertyId: "CH005",
    propertyType: "Individual",
    propName: "House Rules",
    age: "30",
    imageCount: "5",
    fromDate: "15-03-2025",
    toDate: "16-03-2025",
    category: "Resort",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
  {
    id: 3,
    name: "Johan",
    role: "Admin",
    user: "Johan",
    email: "johan@gmail.com",
    password: "Johan",
    type: "Both",
    number: "9878098077",
    toggle: "on",
    status: "on",
    propertyStatus: 3,
    deviceId: "KW-738",
    client: "Device3",
    assigned: "Aravindh",
    location: "Banglore",
    city: "Chennai",
    propertyName: "Enistin",
    propertyId: "AI004",
    propertyType: "Room",
    propName: "Safety & Property",
    age: "35",
    imageCount: "5",
    fromDate: "15-03-2025",
    toDate: "16-03-2025",
    category: "Villa",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
  {
    id: 4,
    name: "Sathish",
    role: "Admin",
    user: "Sathish",
    email: "sathish@gmail.com",
    password: "Sathish",
    type: "Mobile",
    number: "9888098077",
    toggle: "off",
    status: "off",
    propertyStatus: 1,
    deviceId: "KW-838",
    client: "Device4",
    assigned: "Nivin",
    location: "Chennai",
    city: "Tambaram",
    propertyName: "Kudan",
    propertyId: "CH002",
    propertyType: "Individual",
    propName: "House Rules",
    age: "32",
    imageCount: "5",
    fromDate: "15-03-2025",
    toDate: "16-03-2025",
    category: "Resort",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
];

export const property_list = [
  {
    propName: "Cancellation Policy",
    age: "32",
    propertyStatus: 1,
  },
  {
    propName: "House Rules",
    age: "32",
    propertyStatus: 2,
  },
  {
    propName: "Safety & Property",
    age: "32",
    propertyStatus: 3,
  },
];

export const Location_list = [
  {
    area: "Vadapalani",
    city: "Chennai",
    country: "India",
    state: "Tamil Nadu",
    property: "458",
  },
  {
    area: "Tamil Nadu",
    city: "Chennai",
    country: "India",
    state: "Tamil Nadu",
    property: "123",
  },
];
export const Amenities_list = [
  {
    img: "1",
    name: "Jakusci",
  },
  {
    img: "2",
    name: "Hotub",
  },
  {
    img: "3",
    name: "Balcani Swimming Pool",
  },
];
export const receptionList = [
  {
    id: "2298",
    name: "PremKumar",
  },
  {
    id: "2232",
    name: "RamKumar",
  },
  {
    id: "2344",
    name: "SivaRam",
  },
];

export const Transaction_list = [
  {
    transactionId: "Al006",
    propertyName: "Enistin",
    ownerName: "Alber",
    type: "Room",
    location: "Chennai",
    subDate: "22-07-2025",
    expDate: "22-07-2025",
  },
  {
    transactionId: "CH002",
    propertyName: "Kudan",
    ownerName: "Charles",
    type: "Individual",
    location: "Tabaram",
    subDate: "22-07-2025",
    expDate: "22-07-2025",
  },
];
export const Suspended_Property_list = [
  {
    transactionId: "RES 99",
    propertyName: "Resort",
    ownerName: "Alber",
    type: "Room",
    location: "Chennai",
    subDate: "22-07-2025",
    expDate: "22-07-2025",
    user: "Sunil",
    rating: "1",
  },
  {
    transactionId: "RES 99",
    propertyName: "Resort",
    ownerName: "Charles",
    type: "Individual",
    location: "Tabaram",
    subDate: "22-07-2025",
    expDate: "22-07-2025",
    user: "Sunil",
    rating: "1",
  },
];

export const role_list = [
  {
    id: Date.now() + 1,
    name: "Admin",
    module_type: "Admin",
    permissions: [
      { id: 1, name: "List", On: toggle_on, off: toggle_off },
      { id: 2, name: "Add", On: toggle_on, off: toggle_off },
      { id: 3, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 4, name: "View", On: toggle_on, off: toggle_off },
      { id: 5, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: Date.now() + 2,
    name: "Roles",
    module_type: "Roles",
    permissions: [
      { id: 6, name: "List", On: toggle_on, off: toggle_off },
      { id: 7, name: "Add", On: toggle_on, off: toggle_off },
      { id: 8, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 9, name: "View", On: toggle_on, off: toggle_off },
      { id: 10, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: Date.now() + 3,
    name: "User",
    module_type: "User",
    permissions: [
      { id: 11, name: "List", On: toggle_on, off: toggle_off },
      { id: 12, name: "Add", On: toggle_on, off: toggle_off },
      { id: 13, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 14, name: "View", On: toggle_on, off: toggle_off },
      { id: 15, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: Date.now() + 4,
    name: "Call Log",
    module_type: "Call Log",
    permissions: [
      { id: 16, name: "List", On: toggle_on, off: toggle_off },
      { id: 17, name: "Add", On: toggle_on, off: toggle_off },
      { id: 18, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 19, name: "View", On: toggle_on, off: toggle_off },
      { id: 20, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: Date.now() + 5,
    name: "Subscriptions",
    module_type: "Subscriptions",
    permissions: [
      { id: 21, name: "List", On: toggle_on, off: toggle_off },
      { id: 22, name: "Add", On: toggle_on, off: toggle_off },
      { id: 23, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 24, name: "View", On: toggle_on, off: toggle_off },
      { id: 25, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
  {
    id: Date.now() + 6,
    name: "Languages",
    module_type: "Languages",
    permissions: [
      { id: 26, name: "List", On: toggle_on, off: toggle_off },
      { id: 27, name: "Add", On: toggle_on, off: toggle_off },
      { id: 28, name: "Edit", On: toggle_on, off: toggle_off },
      { id: 29, name: "View", On: toggle_on, off: toggle_off },
      { id: 30, name: "Status", On: toggle_on, off: toggle_off },
    ],
  },
];

export const user_review_list = [
  {
    id: 1,
    name: "RamKumar",
    role: "Admin",
    user: "Aravind",
    email: "ramkumar@gmail.com",
    password: "Ramkumar",
    status: 1,
    propertyStatus: 1,
    type: "Mobile",
    number: "9878098077",
    toggle: "on",
    deviceId: "KW-038",
    client: "Device1",
    assigned: "Sathish",
    location: "Hyderabad",
    city: "Chennai",
    propertyName: "Enistin",
    owner_name: "Albert",
    user_name: "Thor",
    propertyId: "AI002",
    rating: 4,
    propertyType: "Room",
    description: " template, seamlessly combined.....",
  },
  {
    id: 2,
    name: "Varun",
    role: "SuperAdmin",
    user: "Varun",
    email: "varun@gmail.com",
    password: "Varun",
    status: 2,
    propertyStatus: 2,
    type: "CRM",
    number: "9435098077",
    toggle: "off",
    status: "off",
    deviceId: "KW-058",
    client: "Device2",
    assigned: "Sambath",
    location: "Madurai",
    city: "Tambaram",
    propertyName: "Kudan",
    owner_name: "Albert",
    user_name: "Thor",
    propertyId: "CH005",
    rating: 2,
    propertyType: "Individual",
    description: " template, seamlessly combined.....",
  },
  {
    id: 3,
    name: "Johan",
    role: "Admin",
    user: "Johan",
    email: "johan@gmail.com",
    password: "Johan",
    type: "Both",
    number: "9878098077",
    toggle: "on",
    status: 2,
    propertyStatus: 1,
    deviceId: "KW-738",
    client: "Device3",
    assigned: "Aravindh",
    location: "Banglore",
    city: "Chennai",
    propertyName: "Enistin",
    owner_name: "Albert",
    user_name: "Thor",
    rating: 4,
    propertyId: "AI004",
    propertyType: "Room",
    description: " template, seamlessly combined.....",
  },
  {
    id: 4,
    name: "Sathish",
    role: "Admin",
    user: "Sathish",
    email: "sathish@gmail.com",
    password: "Sathish",
    type: "Mobile",
    number: "9888098077",
    toggle: "off",
    status: 1,
    propertyStatus: 1,
    deviceId: "KW-838",
    client: "Device4",
    assigned: "Nivin",
    location: "Chennai",
    city: "Tambaram",
    propertyName: "Kudan",
    owner_name: "Albert",
    user_name: "Thor",
    propertyId: "CH002",
    rating: 2,
    propertyType: "Individual",
    description: " template, seamlessly combined.....",
  },
];

export const notification = [
  {
    id: 1,
    msg: "Message 1",
    para: "us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI ",
    time: "02:36 AM, 03-02-2025",
  },
  {
    id: 2,
    msg: "Message 1",
    para: "us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI ",
    time: "02:36 AM, 03-02-2025",
  },
  {
    id: 3,
    msg: "Message 1",
    para: "us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI capabilities.us template, seamlessly combined with AI ",
    time: "02:36 AM, 03-02-2025",
  },
];

export const modules = [
  {
    id: 1,
    module_type: "Admin",
    code: "Admin",
    type: 1,
    permissions: [
      {
        id: 1,
        module_id: 3,
        permission_type: "List",
        code: "CAN-LIST-ADMINS",
      },
      {
        id: 2,
        module_id: 3,
        permission_type: "Add",
        code: "CAN-ADD-ADMINS",
      },
      {
        id: 3,
        module_id: 3,
        permission_type: "Edit",
        code: "CAN-EDIT-ADMINS",
      },
      {
        id: 4,
        module_id: 3,
        permission_type: "View",
        code: "CAN-VIEW-ADMINS",
      },
      {
        id: 5,
        module_id: 3,
        permission_type: "Status",
        code: "CAN-STATUS-ADMINS",
      },
      {
        id: 6,
        module_id: 3,
        permission_type: "Delete",
        code: "CAN-DELETE-ADMINS",
      },
    ],
  },
  {
    id: 2,
    module_type: "Roles",
    code: "Roles",
    type: 1,
    permissions: [
      {
        id: 7,
        module_id: 2,
        permission_type: "List",
        code: "CAN-LIST-ROLES",
      },
      {
        id: 8,
        module_id: 2,
        permission_type: "Add",
        code: "CAN-ADD-ROLES",
      },
      {
        id: 9,
        module_id: 2,
        permission_type: "Edit",
        code: "CAN-EDIT-ROLES",
      },
      {
        id: 10,
        module_id: 2,
        permission_type: "View",
        code: "CAN-VIEW-ROLES",
      },
      {
        id: 11,
        module_id: 2,
        permission_type: "Status",
        code: "CAN-STATUS-ROLES",
      },
      {
        id: 12,
        module_id: 2,
        permission_type: "Delete",
        code: "CAN-DELETE-ROLES",
      },
    ],
  },
  {
    id: 3,
    module_type: "USER",
    code: "USER",
    type: 1,
    permissions: [
      {
        id: 13,
        module_id: 3,
        permission_type: "List",
        code: "CAN-LIST-USER",
      },
      {
        id: 14,
        module_id: 3,
        permission_type: "Add",
        code: "CAN-ADD-USER",
      },
      {
        id: 15,
        module_id: 3,
        permission_type: "Edit",
        code: "CAN-EDIT-USER",
      },
      {
        id: 16,
        module_id: 3,
        permission_type: "View",
        code: "CAN-VIEW-USER",
      },
      {
        id: 17,
        module_id: 3,
        permission_type: "Status",
        code: "CAN-STATUS-USER",
      },
      {
        id: 18,
        module_id: 3,
        permission_type: "Delete",
        code: "CAN-DELETE-USER",
      },
    ],
  },
  {
    id: 4,
    module_type: "Department",
    code: "Department",
    type: 1,
    permissions: [
      {
        id: 19,
        module_id: 4,
        permission_type: "List",
        code: "CAN-LIST-DEPARTMENT",
      },
      {
        id: 20,
        module_id: 4,
        permission_type: "Add",
        code: "CAN-ADD-DEPARTMENT",
      },
      {
        id: 21,
        module_id: 4,
        permission_type: "Edit",
        code: "CAN-EDIT-DEPARTMENT",
      },
      {
        id: 22,
        module_id: 4,
        permission_type: "View",
        code: "CAN-VIEW-DEPARTMENT",
      },
      {
        id: 23,
        module_id: 4,
        permission_type: "Status",
        code: "CAN-STATUS-DEPARTMENT",
      },
      {
        id: 24,
        module_id: 4,
        permission_type: "Delete",
        code: "CAN-DELETE-DEPARTMENT",
      },
    ],
  },
  {
    id: 4,
    module_type: "Location",
    code: "Location",
    type: 1,
    permissions: [
      {
        id: 19,
        module_id: 5,
        permission_type: "List",
        code: "CAN-LIST-LOCATION",
      },
      {
        id: 20,
        module_id: 5,
        permission_type: "Add",
        code: "CAN-ADD-LOCATION",
      },
      {
        id: 21,
        module_id: 5,
        permission_type: "Edit",
        code: "CAN-EDIT-LOCATION",
      },
      {
        id: 22,
        module_id: 5,
        permission_type: "View",
        code: "CAN-VIEW-LOCATION",
      },
      {
        id: 23,
        module_id: 5,
        permission_type: "Status",
        code: "CAN-STATUS-LOCATION",
      },
      {
        id: 24,
        module_id: 5,
        permission_type: "Delete",
        code: "CAN-DELETE-LOCATION",
      },
    ],
  },
];
